import { captureException } from '@sentry/react';
import GeneralError from '@sky-distribution/gp-onboarding-mf-error/src/pages/GeneralError';
import { getAppShellInfo } from '@sky-distribution/gp-onboarding-shared-utils';
import {
  Component, ErrorInfo, PropsWithChildren,
} from 'react';
import { isChunkLoadError, shouldReloadAfterChunkError } from './chunkError';

interface Props {
  isError: boolean;
  errorImg: string;
  onError: () => void;
  previous: () => void;
}

interface State {
  hasError: boolean;
}
export class ErrorBoundary extends Component<PropsWithChildren<Props>, State> {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  resetError = (): void => {
    this.props.previous();
    this.setState({ hasError: false });
  };

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    const appShell = getAppShellInfo();

    captureException(error, {
      contexts: {
        react: { componentStack: errorInfo.componentStack },
        appShell,
      },
      tags: {
        boundary: 'gp-onboarding-app',
        chunkLoadError: isChunkLoadError(error),
        buildHash: appShell.buildHash,
      },
    });

    if (shouldReloadAfterChunkError(error)) {
      window.location.reload();

      return;
    }

    this.props.onError();
  }

  render() {
    if (this.state.hasError) {
      return <GeneralError errorImg={this.props.errorImg} resetError={this.resetError} />;
    }

    return this.props.children;
  }
}
